/**
 * Handed to an item's page through the router's location state, so it can
 * step through the rows it was opened from and close back to that list.
 */
export type CatalogItemNavigation = {
  itemIds: string[];
  listUrl: string;
};

export function getCatalogItemNavigation(
  state: unknown,
): CatalogItemNavigation | null {
  const value = state as Partial<CatalogItemNavigation> | null | undefined;

  if (!Array.isArray(value?.itemIds) || typeof value.listUrl !== 'string') {
    return null;
  }

  return { itemIds: value.itemIds, listUrl: value.listUrl };
}

/* A parent only groups its variations; it has no page of its own to open. */
export function openableItemIds(
  items: { _id: string; is_parent?: boolean | null }[],
): string[] {
  return items.filter(item => !item.is_parent).map(item => item._id);
}
